import { Pipe, PipeTransform } from '@angular/core';
import { mapAndFormatDynamicValue, isDash } from '../../shared/templates/utils/dynamic-data-retrievers';
import { ReportRecord } from '../../models/report.model';
import { DisplayFnArgumentsInfo } from '../../models/template.model';
import { companyFields } from './data-view-helper';
import { LovService } from './data-view-table/lov-service';
import {
  propertyElementTypeFormatter,
  isMeasurementTypeColumn,
  isMeasurementValueColumn,
  propertyMeasurementValueFormatter,
  isMeasurementUnitColumn,
  propertyMeasurementElementNumberFormatter,
} from '../../shared/templates/utils/measurements-correlation';

@Pipe({ name: 'dataViewFormatter' })
export class DataViewFormatterPipe implements PipeTransform {
  constructor(private lovService: LovService) {}
  transform(record: ReportRecord, columnInfo: Partial<DisplayFnArgumentsInfo>): any {
    const column: DisplayFnArgumentsInfo = { ...columnInfo, id: columnInfo.columnId };
    // Check if this is a measurement type column
    if (isMeasurementTypeColumn(column.columnId)) {
      return propertyElementTypeFormatter(record, column, this.lovService.getLookupMap());
    }

    // Check if this is a measurement value column
    if (isMeasurementValueColumn(column.columnId)) {
      return propertyMeasurementValueFormatter(record, column);
    }

    // Check if this is a measurement unit column
    if (isMeasurementUnitColumn(column.columnId)) {
      return propertyMeasurementElementNumberFormatter(record, column);
    }

    let result = mapAndFormatDynamicValue(record, column);
    if (Array.isArray(result) && companyFields.includes(column.field)) {
      result = [...new Set(result.filter(val => !isDash(val)))];
    } else {
      result = Array.isArray(result) ? result.filter(val => !isDash(val)) : !isDash(result) ? result : '';
    }
    return result;
  }
}
